import { withInstall } from '../../utils/install';
import Button from './src/button.vue';

export const IButton = withInstall(Button); // 增加类型

export default IButton;
